export const CASE_CREATION = "CASE_CREATION";
export const UPDATE_PM_CASE_FIELD = "UPDATE_PM_CASE_FIELD";
export const UPDATE_AM_CASE_FIELD = "UPDATE_AM_CASE_FIELD";
export const CLEAR_FORM = "CLEAR_FORM";
export const SET_PM_FORM_DATA = "SET_PM_FORM_DATA";
export const SET_AM_FORM_DATA = "SET_AM_FORM_DATA";

export const _onCreateCase = (data) => {
  return (dispatch) => {
    dispatch({
      type: CASE_CREATION,
      payload: data,
    });
  };
};
export const _onUpdatePmCaseField = (section, field, value) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PM_CASE_FIELD,
      payload: { section, field, value },
    });
  };
};
export const _onUpdateAmCaseField = (section, field, value) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_AM_CASE_FIELD,
      payload: { section, field, value },
    });
  };
};
export const _onSetPmFormData = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_PM_FORM_DATA,
      payload: data,
    });
  };
};
export const _onSetAmFormData = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_AM_FORM_DATA,
      payload: data,
    });
  };
};

export const _clearFormData = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_FORM,
    });
  };
};
